import React, { useState } from 'react';
import PropTypes from 'prop-types';

import Mixpanel from '../shared/Mixpanel';
import StrModal from '../shared/StrModal';
import CopyButton from '../shared/CopyButton';

import './ExportVast.css';

const trackCopyClick = (id) => {
  Mixpanel.track('Copied VAST URL', { creativeId: id });
};

const getCreatives = (groupService, creativeService) => {
  const { group } = groupService;

  if (group && group.creativePreviews && group.creativePreviews.length > 0) {
    return group.creativePreviews;
  }

  return [creativeService.creative];
};

const ExportVast = props => {
  const { CreativeGroupService, CreativeService } = props;
  const [modalVisible, setModalVisible] = useState(false);

  const creatives = getCreatives(CreativeGroupService, CreativeService);

  return (
    <>
      <button
        className="btn btn-primary mr1 pr1"
        aria-haspopup="true"
        onClick={() => setModalVisible(true)}
      >
        Export VAST
      </button>

      <StrModal
        modalClasses="export-modal"
        open={modalVisible}
        hideModal={() => setModalVisible(false)}
        title="VAST tag"
      >
        {creatives.map(creative => (
          <div key={creative.id} className="vast-item">
            <span className="vast-url">{creative.vastTag}</span>
            <CopyButton
              copyContent={creative.vastTag}
              onClick={() => trackCopyClick(creative.id)}
            />
          </div>
        ))}
      </StrModal>
    </>
  );
};

ExportVast.propTypes = {
  CreativeService: PropTypes.object.isRequired,
  CreativeGroupService: PropTypes.object.isRequired,
};

export default ExportVast;
